import { sectionName } from "@/lib/i18n";
// Central Arabic display labels for section slugs. Internal DB values are
// kept in English (palestine, world, …) — visitors always see Arabic.
export const SECTION_LABELS = {
    palestine: "غزة وفلسطين",
    world: "العالم",
    breaking: "عاجل",
    human: "إنساني",
    trend: "ترند",
    video: "فيديو",
    local: "محلي",
    gaza: "غزة وفلسطين", // legacy alias — never let old data leak the English slug
};

export const SECTION_LABELS_EN = { palestine: "Gaza & Palestine", world: "World", breaking: "Breaking", human: "Human", trend: "Trending", video: "Video", local: "Local", gaza: "Gaza & Palestine" };
export const sectionLabel = (slug, lang = "ar") => (lang !== "ar" ? sectionName({ slug }, lang) || SECTION_LABELS_EN[slug] : SECTION_LABELS[slug]) || slug || "";

// SINGLE source of truth for the public menu (desktop top nav, mobile sheet,
// footer). Approved order (reading order, right→left in RTL):
//   الرئيسية | غزة وفلسطين | العالم | من نحن | تواصل معنا
// «عاجل» is intentionally NOT here — it lives only in the red ticker.
export const PUBLIC_NAV_ITEMS = [
    { key: "home", to: "/", label: "الرئيسية", end: true, kind: "static" },
    { key: "palestine", to: "/section/palestine", label: SECTION_LABELS.palestine, kind: "section" },
    { key: "world", to: "/section/world", label: SECTION_LABELS.world, kind: "section" },
    { key: "reels", to: "/reels", label: "الأخبار بالفيديو", kind: "static", icon: "play" },
    { key: "about", to: "/about", label: "من نحن", kind: "page" },
    { key: "contact", to: "/contact", label: "تواصل معنا", kind: "page" },
    { key: "saved", to: "/saved", label: "الأخبار المحفوظة", kind: "saved" },   // reader tool — menu only (not footer)
];

// Section slugs exposed publicly (derived — do not edit separately).
export const PUBLIC_NAV_SLUGS = ["palestine", "world"];

export const shouldShowSectionBadge = (_slug) => false;
